<template>
    <div>
        <v-dialog
            v-model="isOpen"
            max-width="500px"
            >
            <v-card>
                <v-card-title>
                Groep verwijderen
                </v-card-title>
                <v-card-text>
                    Weet u zeker dat u deze Groep wilt verwijderen?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        color="grey"
                        text
                        @click="isOpen=false"
                    >
                        Sluiten
                    </v-btn>
                    <v-btn
                        color="error"
                        text
                        @click="deleteGroep()"
                    >
                        Verwijderen
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn small color="error" @click="isOpen=!isOpen">Verwijder Gebruiker</v-btn>
    </div>
</template>

<script>
import { DELETE_GROUP } from '@/store/actions.type'
import router from "@/router";

export default {
  data(){
    return {
      isOpen: false
    }
  },
  methods: {
    deleteGroep: function () {
      console.log(this.$route.params.id)
      this.$store.dispatch(DELETE_GROUP, { groupId: this.$route.params.id })
      router.push('/')
    }
  }
}
</script>
